/* ─────────────────────────────────────────────────
   deferred-media.js
   DEV-2026-0351: Bilder, die beim Seitenaufbau nicht sichtbar sind, stehen
   nicht mit src im HTML, sondern mit data-src. Erst kurz bevor sie in den
   Sichtbereich kommen, wird geladen.

   Warum nicht loading="lazy": Chrome laedt faule Bilder je nach Verbindung
   mehrere tausend Pixel im Voraus — auf langsamen Verbindungen besonders
   frueh. Auf der Startseite feuerten dadurch 261 Requests sofort und das
   Hero-Bild brauchte fuer 62 KB neun Sekunden, weil die Leitung voll war.

   Hover-Bilder der Produktkarten laden zusaetzlich erst beim ersten Hover
   und nur auf Geraeten, die ueberhaupt hovern koennen. Auf dem Handy ist
   dieses zweite Bild je Karte sonst reine Verschwendung.
   ───────────────────────────────────────────────── */
(function () {
  'use strict';

  var ROOT_MARGIN = '400px';
  var kannHovern = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function laden(el) {
    var picture = el.parentElement;
    if (picture && picture.tagName === 'PICTURE') {
      Array.prototype.forEach.call(picture.querySelectorAll('source[data-srcset]'), function (s) {
        s.srcset = s.dataset.srcset;
        s.removeAttribute('data-srcset');
      });
    }
    if (el.dataset.srcset) {
      el.srcset = el.dataset.srcset;
      el.removeAttribute('data-srcset');
    }
    if (el.dataset.src) {
      el.src = el.dataset.src;
      el.removeAttribute('data-src');
    }
    el.classList.remove('deferred-media--pending');
  }

  /* Hover-Bild: erst beim ersten Zeigen laden, nur wo Hover existiert. */
  function hoverBildVorbereiten(img) {
    if (!kannHovern) return; // Handy/Tablet: wird nie gebraucht
    // Aeusserer Wrapper zuerst: groessere Flaeche, reagiert frueher als die Karte selbst.
    var karte = img.closest('.card-wrapper') || img.closest('.card') || img.parentElement;
    if (!karte) return;
    var einmal = function () {
      laden(img);
      karte.removeEventListener('pointerenter', einmal);
      karte.removeEventListener('focusin', einmal);
    };
    karte.addEventListener('pointerenter', einmal, { once: true });
    karte.addEventListener('focusin', einmal, { once: true });
  }

  // Bereits erfasste Bilder, damit ein erneuter Scan (z. B. nach dem Klonen im
  // infinity-slider) nichts doppelt beobachtet. Klone sind neue Elemente und fehlen hier.
  var erfasst = typeof WeakSet === 'function' ? new WeakSet() : null;
  function neu(img) {
    if (!erfasst) return true;
    if (erfasst.has(img)) return false;
    erfasst.add(img);
    return true;
  }

  // Liefert passende Elemente unterhalb von scope — und scope selbst, falls es passt
  // (der MutationObserver meldet auch einzelne <img> als neuen Knoten).
  function finden(scope, selektor) {
    var treffer = Array.prototype.slice.call(scope.querySelectorAll(selektor));
    if (scope.matches && scope.matches(selektor)) treffer.unshift(scope);
    return treffer;
  }

  var beobachter = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (eintraege, obs) {
      eintraege.forEach(function (eintrag) {
        if (!eintrag.isIntersecting) return;
        laden(eintrag.target);
        obs.unobserve(eintrag.target);
      });
    }, { rootMargin: ROOT_MARGIN })
    : null;

  function beobachten(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var hoverBilder = finden(scope, 'img[data-hover-image][data-src]').filter(neu);
    hoverBilder.forEach(hoverBildVorbereiten);

    var bilder = finden(scope, 'img[data-src]:not([data-hover-image]), img[data-srcset]:not([data-hover-image])').filter(neu);
    // Hover-Bild schon laden, wenn die Karte in Sicht kommt — erst beim Zeigen zu laden
    // hiess: die Karte war beim ersten Hover kurz leer. Auf dem Handy weiterhin nie.
    if (kannHovern) bilder = bilder.concat(hoverBilder);
    if (!bilder.length) return;

    // Ohne IntersectionObserver (sehr alte Browser) sofort alles laden —
    // lieber langsam als unsichtbar.
    if (!beobachter) {
      bilder.forEach(laden);
      return;
    }
    bilder.forEach(function (img) { beobachter.observe(img); });
  }

  // Alles, was spaeter ins DOM kommt ("Mehr laden", Filter, Sortierung, Suche,
  // Slider-Klone, nachgeladene Sections), automatisch erfassen. Ohne das blieben
  // nachgeladene Karten auf dem Platzhalter stehen, weil nur der erste Scan lief.
  var warteschlange = [];
  var geplant = false;
  function abarbeiten() {
    geplant = false;
    var knoten = warteschlange;
    warteschlange = [];
    knoten.forEach(function (k) { if (k.isConnected !== false) beobachten(k); });
  }
  function aufDomAchten() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (aenderungen) {
      aenderungen.forEach(function (a) {
        Array.prototype.forEach.call(a.addedNodes, function (k) {
          if (k.nodeType === 1) warteschlange.push(k);
        });
      });
      if (warteschlange.length && !geplant) {
        geplant = true;
        setTimeout(abarbeiten, 0);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function start() {
    beobachten(document);
    aufDomAchten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme-Editor; deferred-media:scan bleibt als expliziter Weg (z. B. infinity-slider)
  document.addEventListener('shopify:section:load', function (e) { beobachten(e.target); });
  document.addEventListener('deferred-media:scan', function (e) { beobachten(e.detail && e.detail.root); });
})();
